<template>
    <SecondLevelTabs :tabs="secondLevelInfoTabs" translation-key="product_tabs">
        <template v-slot:general>
            <product-description-form />
        </template>
        <template v-if="authStore.isTO1" v-slot:day_by_day>
            <InfoItineraryDescription :contract-id="supplierStore.contract.id" />
        </template>
        <template v-if="authStore.isTO1" v-slot:destinations_and_hotels>
            <ProductTourDestinations />
        </template>
    </SecondLevelTabs>
</template>
<script setup lang="ts">
    import ProductDescriptionForm from '~/components/supplier/ProductDescriptionForm.vue'
    import InfoItineraryDescription from '~/components/products/information/InfoItineraryDescription.vue'
    import ProductTourDestinations from '~/components/products/tours/ProductTourDestinations.vue'

    const secondLevelInfoTabs = ['general', 'day_by_day', 'destinations_and_hotels']
</script>
